// FiltroMobileModal.tsx
import React from "react";
import { Modal, Button, DatePicker, Select, Form } from "antd";
import dayjs from "dayjs";

interface Props {
  visible: boolean;
  onClose: () => void;
  onApply: (values: any) => void;
  filtros: Record<string, any>;
}

const { Option } = Select;

const situacoes = [
  
  { label: "Não definido", value: "Não definido", color: "white" },
  { label: "Alugar", value: "Alugar", color: "green" },
  { label: "Alugar ou trocar", value: "Alugar ou trocar", color: "green" },
  {
    label: "Alugado ou utilizado parcialmente",
    value: "Alugado ou utilizado parcialmente",
    color: "green",
  },
  { label: "Trocar", value: "Trocar", color: "green" },
  // { label: "Trocado", value: "trocado", color: "blue" },
  { label: "Utilizado", value: "Será utilizado", color: "blue" },
  { label: "Reservado", value: "Reservado pelo próprio", color: "purple" },
  { label: "Reservado por MC(Multicotas)", value: "Reservado por MC", color: "purple" },
  {
    label: "Periodos fracionados reservados",
    value: "Períodos fracionados reservados",
    color: "purple",
  },
  { label: "Fechado parcialmente", value: "fechado_parcialmente", color: "orange" },
  { label: "Fechado", value: "fechado", color: "red" },
];

export const FiltroMobileModal: React.FC<Props> = ({
  visible,
  onClose,
  onApply,
  filtros,
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then((values) => {
      onApply(values);
      onClose();
    });
  };

  const handleClear = () => {
    form.resetFields();
    onApply({});
    onClose();
  };

  return (
    <Modal
      title="Filtros"
      open={visible}
      onOk={handleOk}
      onCancel={onClose}
      footer={[
        <Button key="limpar" onClick={handleClear}>
          Limpar
        </Button>,
        <Button key="aplicar" type="primary" onClick={handleOk}>
          Aplicar
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" initialValues={filtros}>
        <Form.Item name="situacao" label="Situação">
          <Select
            mode="multiple"
            placeholder="Filtrar Situação"
            style={{ width: "100%" }}
          >
            {situacoes.map((item) => (
              <Option key={item.value} value={item.value}>
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: item.color,
                      display: "inline-block",
                      border: "grey solid 1px", 
                    }}
                  />
                  {item.label}
                </span>
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Adicione outros filtros aqui se quiser, como check-in/check-out, etc. */}
      </Form>
    </Modal>
  );
};
